type Option = {
  value: string,
  label: string,
}

export const FREQUENCY_UNIT_OPTIONS: Option[] = [
  {value: 'HOUR', label: 'Ore'},
  {value: 'DAY', label: 'Giorni'},
  {value: 'WEEK', label: 'Settimane'},
  {value: 'MONTH', label: 'Mesi'}
]

export const TOLERANCE_DAYS_UNIT_OPTIONS: Option[] = [
  {value: '+', label: '+'},
  {value: '-', label: '-'},
  {value: '+/-', label: '+/-'}
]

export const DOSAGE_UNIT_OPTIONS: Option[] = [
  {value: 'mg', label: 'mg'},
  {value: 'ml', label: 'ml'},
  {value: 'UI', label: 'UI'},
  {value: 'Fiale', label: 'Fiale'},
  {value: 'Pillole', label: 'Pillole'},
  {value: 'Compresse', label: 'Compresse'},
  {value: 'mg/ml', label: 'mg/ml'},
  {value: 'mg/Kg-WEIGHT', label: 'mg/Kg peso'},
  {value: 'ng/Kg-WEIGHT', label: 'ng/Kg peso'}
]

export const VIAL_DOSAGE_UNIT_OPTIONS: Option[] = [
  {value: 'mg', label: 'mg'},
  {value: 'ml', label: 'ml'},
  {value: 'UI', label: 'UI'}
]

export const INFUSION_RATE_UNIT_OPTIONS: Option[] = [
  {value: 'ng/kg/min', label: 'ng/kg/min'},
  {value: 'ml/h', label: 'ml/h'},
  {value: 'ml/min', label: 'ml/min'},
  {value: 'mg/h', label: 'mg/h'},
  {value: 'mg/min', label: 'mg/min'}
]

export const CALCULATION_CRITERION_UNIT_OPTIONS: Option[] = [
  {value: 'UI/Kg', label: 'UI/Kg'},
  {value: 'mg/Kg', label: 'mg/Kg'},
  {value: 'ml/Kg', label: 'ml/Kg'},
  {value: 'fiale/Kg', label: 'fiale/Kg'}
]

export const WEEKDAY_OPTIONS: Option[] = [
  {value: 'MONDAY', label: 'Lunedì'},
  {value: 'TUESDAY', label: 'Martedì'},
  {value: 'WEDNESDAY', label: 'Mercoledì'},
  {value: 'THURSDAY', label: 'Giovedì'},
  {value: 'FRIDAY', label: 'Venerdì'},
  {value: 'SATURDAY', label: 'Sabato'},
  {value: 'SUNDAY', label: 'Domenica'}
]

export const MODE_OF_ASSUMPTION_OPTIONS: Option[] = [
  {value: 'INTRAVENOUS', label: 'Endovena'},
  {value: 'SUBCUTANEOUS', label: 'Sottocute'},
  {value: 'INTRAMUSCOLAR', label: 'Inframuscolo'},
  {value: 'ORAL', label: 'Orale'},
  {value: 'INHALATION', label: 'Inalazione'},
  {value: 'TOPICAL', label: 'Topica'}
]

export const DEVICE_OF_ASSUMPTION_OPTIONS: Option[] = [
  {value: 'PEN', label: 'Penna'},
  {value: 'SYRINGE', label: 'Siringa preriempita'},
  {value: 'PUMP', label: 'Pompa'},
  {value: 'INHALER', label: 'Inalatore'}
]

export const SPEED_UNIT_OPTIONS: Option[] = [
  {value: 'ng/kg/min', label: 'ng/kg/min'},
  {value: 'ml/h', label: 'ml/h'},
  {value: 'ml/min', label: 'ml/min'}
]

export const DEFAULT_FREQUENCY_UNIT_TYPE = 'DAY'
export const DEFAULT_TOLERANCE_DAYS_UNIT_TYPE = '+/-'
export const DEFAULT_DOSAGE_UNIT_TYPE = 'mg'
export const DEFAULT_INFUSION_RATE_UNIT_TYPE = 'ng/kg/min'
export const DEFAULT_CALCULATION_CRITERION_UNIT_TYPE = 'UI/Kg'
export const DEFAULT_SPEED_UNIT_TYPE = 'ng/kg/min'
